// import { rejectToAgent } from '@/API';
import { getLoginUser, rejectToAgent, saveOrderContractInfo } from '@/API';
import { cancelOrderForCes } from '@/API/international';
import { buildIntlOrderPublishComplianceRequest, checkIntlExportCompliance } from '@/libs/exportCompliance';
export default {
  methods: {
    async submit (val, cal) {
      let baseR = true;
      let Product = {};
      let error = '';
      if (!val) {
        baseR = await this.$refs.baseInfo.validate();
      } else {
        baseR = await this.$refs.baseInfo.validatedrafts();
      }
      if (!baseR) {
        this.loading = false;
        cal(false);
        return;
      }
      if (val) {
        Product = await this.$refs.product.validateDraft();
      } else {
        Product = await this.$refs.product.validate();
      }

      if (baseR && Product) {
        val ? baseR.contractInfo.isDraft = true : baseR.contractInfo.isDraft = false;

        let newProductList = [];
        Product.productList.forEach((item) => {
          item.authorizationEmail = this.form.authorizationEmail;
          newProductList.push(item);
        });
        if (val !== 1) {
          newProductList.forEach((item) => {
            if (!item.materialUnit) {
              error = `${item.materialNumberId}料号单位为空，请联系管理员`;
            }
          });
        }

        let contractDetail = {
          actualSettlementAmount: Product.actualSettlementAmount,
          orderSales: Product.orderSales,
          productServiceProviderA: this.form.productServiceProviderA,
          productServiceProviderB: this.form.productServiceProviderB,
          productServiceProviderC: this.form.productServiceProviderC,
          serviceSubjectName: this.form.serviceSubjectName
        };

        baseR.contractDetail = { ...baseR.contractDetail, ...contractDetail };

        if (error) {
          this.$notify.error(error);
          this.$refs.actions.loading = false;
          return;
        }

        if (!val) {
          this.loading = true;
          const decision = await checkIntlExportCompliance(this,
            buildIntlOrderPublishComplianceRequest(this.form, newProductList));
          if (!decision.allowBusiness) {
            this.loading = false;
            cal(false);
            return;
          }
        }

        this.loading = true;
        saveOrderContractInfo({ ...baseR, contractProductInfos: newProductList }).then((res) => {
          let json = res.data;
          this.loading = false;
          cal(false);
          if (json.status === '200') {
            if (val) {
              this.$router.replace({ name: 'orderPersionDrafts' });
            } else {
              this.$router.replace({ name: 'orderPersionContractList' });
            }
          }
        }).catch(() => {
          this.loading = false;
          cal(false);
        });
      } else {
        this.loading = false;
        cal(false);
      }
    },
    // 订单员驳回
    Reject (cal) {
      if (this.form.contractType === '国际分销下单') {
        rejectToAgent(this.form.id).then((res) => {
          cal();
          let json = res.data;
          if (json.status === '200') {
            getLoginUser().then(({ data: { status, data } }) => {
              if (Number(status) === 200) {
                const params = {
                  orderId: this.form.smeFromId,
                  createUserId: data.userId,
                  createUserName: data.userName,
                  approveStep: 'CesStepName_8',
                  remark: this.$refs.rejected.$data.rejectedForm.rejectedInfo
                };
                cancelOrderForCes(params).then(({ status, data }) => {
                  cal();
                  if (Number(status) === 200) {
                    this.$router.replace({
                      name: 'orderPersionContractList'
                    });
                  }
                }).catch(() => {
                  cal();
                });
              }
            });
          }
        }).catch(() => {
          cal();
        });
      } else {
        rejectToAgent(this.form.id).then((res) => {
          cal();
          let json = res.data;
          if (json.status === '200') {
            this.$router.replace({
              name: 'orderPersionContractList'
            });
          }
        }).catch(() => {
          cal();
        });
      }
    },
    suggestionInfo () {
      this.$refs.rejected.showRejectDialog();
    },
    abandonedOrder () {
      this.$confirm('确认废弃吗？').then((_) => {
        getLoginUser().then(({ data: { status, data } }) => {
          if (Number(status) === 200) {
            const params = {
              orderId: this.form.smeFromId,
              createUserId: data.userId,
              createUserName: data.userName,
              approveStep: 'StepName_Canceled',
              remark: this.$refs.rejected.$data.rejectedForm.rejectedInfo
            };
            cancelOrderForCes(params).then(({ status, data }) => {
              if (Number(status) === 200) {
                this.$router.replace({
                  name: 'orderPersionContractList'
                });
              }
            }).catch((e) => {
              console.log(e);
            });
          }
        });
      }).catch((e) => {
        this.$message.info('取消废弃');
      });
    }
  }
};
